import React from 'react';
import store from '@/redux/index';
import { IM_MESSAGE, IM_USER_INFO } from '@/typings/global';

const { dispatch, getState } = store;

const GM_INFO = (
    avatar: IM_MESSAGE['avatar'],
    nick: IM_MESSAGE['nick']
): { avatar: string; nick: string } => {
    const {
        base_config: { gm }
    } = getState().IndexReducer;
    if (avatar !== 'faq') {
        return { avatar: avatar || gm.gm_avatar, nick: nick || gm.nick };
    }
    return { avatar: gm.faq_gm_avatar, nick: gm.nick };
};
const IM_INFO = (
    avatar: IM_MESSAGE['avatar'],
    nick: IM_MESSAGE['nick']
): { avatar: string; nick: string | number } => {
    const { user_nick, user_head_img } = getState().IndexReducer;
    // 非faq且非离线且非视频，返回队列中的头像及昵称
    if (avatar !== 'faq' && avatar !== 'offline' && avatar !== 'video') {
        return { avatar, nick };
    }
    return { avatar: user_head_img, nick: user_nick };
};

export function registerUserInfo(data: IM_USER_INFO): void {
    const userInfo = getState().IndexReducer;
    dispatch({
        type: 'SET_USER_INFO',
        payload: { ...userInfo, ...data }
    });
}

export const GM_AVATAR = (avatar: IM_MESSAGE['avatar'], nick: IM_MESSAGE['nick']): JSX.Element => {
    return (
        <div className="im-message-userinfo">
            <img
                style={{
                    userSelect: 'none'
                }}
                onTouchStart={(e) => e.preventDefault()}
                src={GM_INFO(avatar, nick).avatar}
                alt="用户头像"
            />
        </div>
    );
};
export const IM_AVATAR = (avatar: IM_MESSAGE['avatar'], nick: IM_MESSAGE['nick']): JSX.Element => {
    return (
        <div className="im-message-userinfo">
            <img
                style={{
                    userSelect: 'none'
                }}
                onTouchStart={(e) => e.preventDefault()}
                src={IM_INFO(avatar, nick).avatar}
                alt="用户头像"
            />
        </div>
    );
};
export const GM_NICK = (avatar: IM_MESSAGE['avatar'], nick: IM_MESSAGE['nick']): JSX.Element => {
    const { is_vip } = IM.SDKServer.getState();
    return (
        <span className="nick-wrap">
            <span className="nick">{GM_INFO(avatar, nick).nick}</span>
            {avatar !== 'faq' && is_vip && (
                <span className="privilege">
                    <i />
                    专属客服
                </span>
            )}
        </span>
    );
};
export const IM_NICK = (avatar: IM_MESSAGE['avatar'], nick: IM_MESSAGE['nick']): JSX.Element => {
    const { is_vip } = IM.SDKServer.getState();
    const {
        base_config: { user_info }
    } = getState().IndexReducer;
    return (
        <span className="nick-wrap">
            <span className="nick">{IM_INFO(avatar, nick).nick}</span>
            {is_vip && !!user_info.vip_level && (
                <span className="vip">{`VIP${user_info.vip_level}`}</span>
            )}
        </span>
    );
};
